export default __webpack_public_path__ + "static/media/cooperation.273d94de.png";